import React from 'react'

const DeviceManagement = () => {
  return (
    <div>
      hello
    </div>
  )
}

export default DeviceManagement
